module.exports = __webpack_public_path__ + "static/media/FutureSecure.41bec754.jpg";